
export default (state = {}, action) => {
  switch (action.type) {
    case 'COMMENT_UPDATE_BEGINS':
      return {
        loader: true,
        error: false,
        result: null,
      
      }
    case 'COMMENT_UPDATE_SUCCESS':
      return {
        loader: false,
        error: false,
        result: action.payload,
    
      }
    case 'COMMENT_UPDATE_FAILURE':
      return {
        loader: false,
        error: true,
        result: null,
      

      }
    case 'COMMENT_UPDATE_CLEAR':
      return {
        loader: false,
        error: false,
        result: null,
      

      }
    default:
      return state
  }
}